import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-list-page',
  templateUrl: './courses-list-page.component.html',
  styleUrls: ['./courses-list-page.component.scss']
})
export class CoursesListPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
